import morph from "../helpers/morph";

class PdpVariantButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.linkEl = this.closest("[data-variant-link]");

    if (!this.linkEl) return;

    this.handleLinkClick = (e) => {
      e.preventDefault();
      this.selectVariant();
    };

    this.linkEl.addEventListener("click", this.handleLinkClick);
  }

  disconnectedCallback() {
    this.linkEl?.removeEventListener("click", this.handleLinkClick);
  }

  selectVariant() {
    const url = new URL(
      this.getAttribute("product-url"),
      window.location.origin,
    );
    const targetSelector = "#MainContent";

    window.theme
      .fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const section = new DOMParser().parseFromString(text, "text/html");

        const targetEl = document
          .createRange()
          .createContextualFragment(
            section.querySelector(targetSelector).outerHTML,
          );

        if (!window.Shopify.designMode && this.updateUrl) {
          url.searchParams.delete("section_id");
          window.theme.replaceState("", "", url);
        }

        morph(this.closest(targetSelector), targetEl);
      });
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }
}

if (!customElements.get("pdp-variant-button")) {
  customElements.define("pdp-variant-button", PdpVariantButton);
}
